const Direction = {
  north: 1 << 0,
  east: 1 << 1,
  south: 1 << 2,
  west: 1 << 3
};

export { Direction };
//# sourceMappingURL=types.mjs.map
